import sample_1 from './idealProtectSpecial.jpg';

export const idealProtectSpecialImpressions = {
    sample_1,
};
